import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import axios from 'axios';
import { toast } from 'sonner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const AuthCallback = () => {
  const navigate = useNavigate();
  const { setUser, setToken } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processOAuth = async () => {
      try {
        const params = new URLSearchParams(window.location.search);
        const code = params.get('code');

        if (!code) {
          toast.error('Authentication failed — no code received');
          navigate('/auth');
          return;
        }

        const redirectUri = window.location.origin + '/auth/callback';
        const response = await axios.post(`${API}/auth/google`, {
          code,
          redirect_uri: redirectUri
        });

        const { token, user } = response.data;

        localStorage.setItem('token', token);
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;

        setToken(token);
        setUser(user);

        window.history.replaceState({}, document.title, '/dashboard');
        navigate('/dashboard', { replace: true });
        toast.success(`Welcome, ${user.name}!`);

      } catch (error) {
        toast.error('Google login failed. Please try again.');
        navigate('/auth');
      }
    };

    processOAuth();
  }, [navigate, setUser, setToken]);

  return (
    <div className="flex items-center justify-center min-h-screen bg-background">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto mb-4"></div>
        <p className="text-earth-600">Completing authentication...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
